import JupiterProfit from './jupiter.png';
import NmtProfit from './nmt.png';
import OndoProfit from './ondo.png';
import HypeProfit from './hype.png';

const ProfitExamples2 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        Negative realized profits
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(2, 1fr)',
          gridTemplateColumns: 'repeat(2, 1fr)',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={JupiterProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={NmtProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={OndoProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={HypeProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
      </div>
    </div>
  );
};

export default ProfitExamples2;
